import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Menu.css';

class Menu extends Component {
	constructor() {
		super();
		this.state = {
			isOpen: false
		}
	}

	openMenu = (e) => {
		this.setState({ isOpen: true });
	}

	closeMenu = (e) => {
		this.setState({ isOpen: false });
	}

	render() {
		let dropdown;
		let overlay;

		if (this.state.isOpen) {
			dropdown =
				<div className="dropdown">
					<ul>
						{this.props.isAdmin ? <li><Link to={"/admin"}>Admin</Link></li> : null}
						<li><Link to={"/info"}>Info</Link></li>
						<li><Link to={"/members"}>Members</Link></li>
						{this.props.auth ? <li><a onClick={this.props.auth}>{this.props.authText}</a></li> : null}
					</ul>
				</div>;
			overlay = <div onClick={this.closeMenu} className="overlay"></div>;
		}

		return (
			<div id="menu">
				<a
					onClick={this.openMenu}
					className={"menu-trigger " + (this.state.isOpen ? 'open' : '')}>
				☰</a>
				{dropdown}
				{overlay}
			</div>
		);
	}
}

export default Menu;


// WEBPACK FOOTER //
// ./src/Menu.js